import { useTranslation } from '@aimsos/i18n';
import { Button, IconHighlight, ModalLayout } from '@aimsos/ui';

import { useModalEscape } from '../hooks/useModalEscape.js';
import { ModalFooter } from './parts';

import { TriangleAlert } from 'lucide-react';

/**
 * Unsaved-changes confirm for `Cancel` (CT-5190 / DS-3).
 *
 * `ModalLayout` + `useBodyPortal`, never `window.confirm` — a native dialog is
 * unstyled, untranslatable and blocks the main thread.
 */
function DiscardChangesModal({ isOpen, onKeepEditing, onDiscard }) {
  const { t } = useTranslation('dashboards');

  useModalEscape(isOpen, onKeepEditing);
  if (!isOpen) return null;

  return (
    <ModalLayout
      isOpen={isOpen}
      onClose={onKeepEditing}
      useBodyPortal
      maxWidthClassName="max-w-md"
      titlePrefix={
        <IconHighlight icon={TriangleAlert} bgColor="Yellow" iconColor="Yellow" size="medium" />
      }
      title={t('widgetBuilder.discard.title')}
    >
      <div className="px-6 py-4">
        <p className="text-sm text-content-secondary">{t('widgetBuilder.discard.body')}</p>
      </div>

      <ModalFooter
        cancelLabel={t('widgetBuilder.discard.keepEditing')}
        onCancel={onKeepEditing}
        primaryAction={
          <Button variant="danger" onClick={onDiscard} className="!text-[12px]">
            {t('widgetBuilder.discard.confirm')}
          </Button>
        }
      />
    </ModalLayout>
  );
}

export default DiscardChangesModal;
